// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageViewsStatusIcon__icon-f46229 {
  --ic-status-default: var(--chat-bubble-primary);
  --ic-status-failed-color: var(--addition-50);
  --ic-status-failed-fill: var(--danger-40);
  --ic-status-sending: var(--chat-bubble-text-secondary);
}

.MessageViewsStatusIcon__fixed-color-ce4424 {
  --ic-status-default: var(--addition-50);
  --ic-status-failed-color: var(--danger-40);
  --ic-status-failed-fill: var(--addition-50);
  --ic-status-sending: var(--addition-50);
}

.MessageViewsStatusIcon__default-f4c0c1 {
  fill: var(--ic-status-default);
}

.MessageViewsStatusIcon__failed-f1cba5 {
  color: var(--ic-status-failed-color);
  fill: var(--ic-status-failed-fill);
}

.MessageViewsStatusIcon__sending-a09682 {
  fill: var(--ic-status-sending);
}`, "",{"version":3,"sources":["webpack://./src/components/MessageViews/MessageViewsStatusIcon/MessageViewsStatusIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,+CAAA;EACA,4CAAA;EACA,yCAAA;EACA,sDAAA;AACF;;AAEA;EACE,uCAAA;EACA,0CAAA;EACA,2CAAA;EACA,uCAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,oCAAA;EACA,kCAAA;AACF;;AAEA;EACE,8BAAA;AACF","sourcesContent":[".icon {\n  --ic-status-default: var(--chat-bubble-primary);\n  --ic-status-failed-color: var(--addition-50);\n  --ic-status-failed-fill: var(--danger-40);\n  --ic-status-sending: var(--chat-bubble-text-secondary);\n}\n\n.fixed-color {\n  --ic-status-default: var(--addition-50);\n  --ic-status-failed-color: var(--danger-40);\n  --ic-status-failed-fill: var(--addition-50);\n  --ic-status-sending: var(--addition-50);\n}\n\n.default {\n  fill: var(--ic-status-default);\n}\n\n.failed {\n  color: var(--ic-status-failed-color);\n  fill: var(--ic-status-failed-fill);\n}\n\n.sending {\n  fill: var(--ic-status-sending);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `MessageViewsStatusIcon__icon-f46229`,
	"fixed-color": `MessageViewsStatusIcon__fixed-color-ce4424`,
	"fixedColor": `MessageViewsStatusIcon__fixed-color-ce4424`,
	"default": `MessageViewsStatusIcon__default-f4c0c1`,
	"failed": `MessageViewsStatusIcon__failed-f1cba5`,
	"sending": `MessageViewsStatusIcon__sending-a09682`
};
module.exports = ___CSS_LOADER_EXPORT___;
